/**
 * VideoGenerationContext
 *
 * Provides isBackendConnected and externalConfigUpdate to the VideoPage
 * component tree, eliminating prop drilling through VideoTabContent into
 * FullVideoTab.
 */

import React, { useMemo } from 'react';
import type { VideoConfig } from '@/types';
import {
  VideoGenerationContext,
  type VideoGenerationContextValue,
} from './VideoGenerationContext.context';

interface VideoGenerationProviderProps {
  isBackendConnected: boolean | null;
  externalConfigUpdate?: Partial<VideoConfig> | null;
  children: React.ReactNode;
}

export function VideoGenerationProvider({
  isBackendConnected,
  externalConfigUpdate,
  children,
}: VideoGenerationProviderProps): JSX.Element {
  const value = useMemo<VideoGenerationContextValue>(
    () => ({ isBackendConnected, externalConfigUpdate }),
    [isBackendConnected, externalConfigUpdate]
  );

  return (
    <VideoGenerationContext.Provider value={value}>{children}</VideoGenerationContext.Provider>
  );
}
